import { UniBoxMain as Component } from "./UniBoxMain";
import {
    UniBoxMainSlotBottom as SlotBottom,
    UniBoxMainSlotBottomLeft as SlotBottomLeft,
    UniBoxMainSlotBottomRight as SlotBottomRight,
    UniBoxMainSlotLeft as SlotLeft,
    UniBoxMainSlotMiddle as SlotMiddle,
    UniBoxMainSlotRight as SlotRight,
    UniBoxMainSlotTop as SlotTop,
    UniBoxMainSlotTopLeft as SlotTopLeft,
    UniBoxMainSlotTopRight as SlotTopRight,
} from "./components/Slot/UniBoxMainSlot";

interface IUniBoxMainExtensions {
    SlotBottom: typeof SlotBottom;
    SlotBottomLeft: typeof SlotBottomLeft;
    SlotBottomRight: typeof SlotBottomRight;
    SlotLeft: typeof SlotLeft;
    SlotMiddle: typeof SlotMiddle;
    SlotRight: typeof SlotRight;
    SlotTop: typeof SlotTop;
    SlotTopLeft: typeof SlotTopLeft;
    SlotTopRight: typeof SlotTopRight;
}

export const UniBoxMain: typeof Component & IUniBoxMainExtensions =
    Object.assign(Component, {
        SlotBottom,
        SlotBottomLeft,
        SlotBottomRight,
        SlotLeft,
        SlotMiddle,
        SlotRight,
        SlotTop,
        SlotTopLeft,
        SlotTopRight,
    });

export type { UniBoxMainProps } from "./types";
